<script setup>
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import {computed, ref, watch} from "vue";
import useApprovalSettings from "@/composables/approval-center/settings/useApprovalSettings";

const showSaveChanges = ref(false);
const approvalTime = ref(false);

const {settingsQuery, saveSettingsMutation} = useApprovalSettings();
const { isLoading, isFetching } = settingsQuery;
const { mutate: saveSettings, isPending: saving } = saveSettingsMutation;

const settings = computed(() => settingsQuery.data.value);

watch(settings, () => {
  approvalTime.value = settings.value?.approval_time || 5;
}, {
  immediate: true,
  deep: true,
})

watch(
  [approvalTime],
  ([newTime]) => {
    if (isLoading.value || isFetching.value) {
      return;
    }

    if (parseInt(newTime) !== settings.value?.approval_time) {
      handleSave();
    }
  },
);

const handleSave = () => {
  if (saving.value) {
    return;
  }

  saveSettings(
    {
      approval_time: Number(approvalTime.value),
    },
    {
      onSuccess: () => {
        showSaveChanges.value = false;
      },
    },
  );
}
</script>
<template>
  <div>
    <div class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-gap-y-8 tw-w-full tw-transition-all tw-duration-300">
      <div class="tw-flex tw-flex-col tw-gap-10">
        <div class="tw-flex tw-justify-between tw-items-center">
          <p class="tw-font-bold tw-text-neutral-900 tw-text-2.5xl">
            Default Approval Time
          </p>

          <CustomMultiselect
            v-model="approvalTime"
            class="tw-text-left tw-h-12.5 tw-relative tw-w-[232px]"
            :close-on-select="true"
            :options="{
              5: '1 week (default)',
              10: '2 weeks',
              15: '3 weeks'
            }"
            :searchable="false"
            :can-deselect="false"
            :disabled="saving"
          />
        </div>

        <div class="tw-flex tw-flex-col tw-gap-8 tw-text-lg">
          <p class="tw-text-neutral-900 tw-text-base tw-leading-snug">
            When your SEO agent completes an item, it appears in your Approval Center and will automatically approve after the default review period. You can use this setting to change that automatic approval time from one week to two or three weeks. This gives you more time to review, request changes, or manually approve items before they’re finalized.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
